export const setChargeMenu = async (context, chargeMenu) => {
  context.commit('SET_CHARGE_MENU', chargeMenu)
}
